import React from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";

const GetInTouch = () => {
  return (
    <div className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
            Get In Touch
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-2"></div>
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
            Ready to start your tech journey? Get in touch with us through any of these channels.
          </p>
        </div>

        {/* Contact Options */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FaMapMarkerAlt className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold text-gray-900 mb-2">Visit Our Campus</h3>
            <p className="text-gray-600">
            49/6, Balaji Nagar,
             Panpozhi, Tenkasi, Tamil Nadu - 627 807<br />
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FaPhone className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold text-gray-900 mb-2">Call Us</h3>
            <p className="text-gray-600">
            +91 91500 80333<br />
            +91 91500 80347<br />
            +91 91500 80348
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FaEnvelope className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold text-gray-900 mb-2">Email Us</h3>
            <p className="text-gray-600">
            info@insytix.com<br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;


